import React, { useState }  from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { SidebarData } from './sidebarData';
import SubMenu from './subMenu';
import './sidebar.css';
import { useAuth } from '../../../context/AuthContext';

const Nav = styled.div`
height: 60px;
display: flex;
justify-content: space-between;
align-items: center;
position: absolute;
`

const NavIcon = styled(Link)`
position: fixed;
color: #265384;
margin: 0 1.5rem;
font-size: 2rem;
height: 80px;
display: flex;
justify-content: flex-start;
align-items: center;
`

const SidebarNav = styled.nav`
background: #15171c;
width: 190px;
height: 100vh;
display: flex;
justify-content: center;
position: fixed;
top: 0;
left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
transition: 850ms;
z-index: 10;
`

const SidebarWrap = styled.div`
width: 100%;
background-color: #9E74CE;
`

const Usuario = ({ isLoggedIn }) => {
    if(isLoggedIn) {
        return(
            <Link className='btn btn-danger' to='/logout'>
                Cerrar Sesión
            </Link>
        )
    }
}

const Sidebar = () => {
    const { isAuthenticated, isLoading: authLoading } = useAuth();
    const [sidebar, setSidebar] = useState(false)
    const showSidebar = () => setSidebar(!sidebar);
    const isLoggedIn = isAuthenticated && !authLoading;

  return (
    <>
    <Nav>
            <NavIcon to="#">
                <FaIcons.FaBars onClick={showSidebar} />
            </NavIcon>
    </Nav>
    <div className='usuario'>
        <Usuario isLoggedIn={isLoggedIn} />
    </div>
    <SidebarNav sidebar={sidebar}>
        <SidebarWrap>
            <NavIcon to="#">
                <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon>
            <div style={{ marginTop: '80px' }}>
                {SidebarData.map((item, index) => {
                    return <SubMenu item={item} key={index} login={isLoggedIn} />;
                })}
            </div>
        </SidebarWrap>
    </SidebarNav>
    </>
  )
}

export default Sidebar
